import React from 'react';
import { Link } from '@sls-react/routing';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import { LinkProps } from 'next/link';

type Props = AnchorProps & {
  linkProps?: LinkProps;
};

const AboutUsLink: React.FC<Props> = ({ children, linkProps, ...props }) => (
  <Link href="/about" passHref {...linkProps}>
    <A {...props}>{children}</A>
  </Link>
);

export default AboutUsLink;
